import { render, staticRenderFns } from "./source-attributes.vue?vue&type=template&id=609695ea"
import script from "./source-attributes.vue?vue&type=script&lang=js"
export * from "./source-attributes.vue?vue&type=script&lang=js"
import style0 from "./source-attributes.vue?vue&type=style&index=0&id=609695ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports